module.exports = __webpack_public_path__ + "static/Zam.e3d5a555.png";